import { useFlags } from 'launchdarkly-react-client-sdk'
import { Typography } from '@mui/material'
import { Redeem as GiftIcon } from '@mui/icons-material'
import { ListItem } from '../NavBar/Components/Jasper/JasperLink'

const sparkNextLink = process.env.REACT_APP_SPARK_NEXT_URL

const SparkNextLink = () => {
    const { releaseSparkNextLink } = useFlags()

    if (!releaseSparkNextLink || !sparkNextLink) {
        return <div />
    }

    return (
        <div>
            <a href={sparkNextLink} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
                <ListItem className="hoverIndex">
                    <GiftIcon sx={{ paddingLeft: '10px' }} />
                    <Typography
                        sx={{ display: 'flex', justifyContent: 'flex-start', paddingLeft: '25px', width: '100%' }}
                        variant="body2"
                    >
                        Spark NEXT
                    </Typography>
                </ListItem>
            </a>
        </div>
    )
}

export default SparkNextLink
